export * from './geral.api';
export * from './simulador.api';
